import { Link } from "wouter";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface MemberLinkProps {
  userId: string;
  name: string;
  companyLogo?: string | null;
  showAvatar?: boolean;
  avatarSize?: "sm" | "md" | "lg";
  className?: string;
  "data-testid"?: string;
}

export default function MemberLink({ 
  userId, 
  name, 
  companyLogo, 
  showAvatar = false,
  avatarSize = "sm",
  className = "",
  "data-testid": testId
}: MemberLinkProps) {

  const getInitials = () => {
    if (!name) return "??";
    const parts = name.trim().split(/\s+/).filter(p => p.length > 0);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return "??";
  };

  const avatarSizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10"
  };

  const textSizeClasses = {
    sm: "text-xs",
    md: "text-sm",
    lg: "text-base"
  };

  return (
    <Link
      href={`/profile/${userId}`}
      onClick={(e) => e.stopPropagation()}
      className={`inline-flex items-center gap-2 hover:underline cursor-pointer ${className}`}
      data-testid={testId || `link-member-${userId}`}
    >
      {showAvatar && (
        <Avatar className={avatarSizeClasses[avatarSize]}>
          {companyLogo ? (
            <AvatarImage src={companyLogo.startsWith('/objects/') ? companyLogo : `/objects/${companyLogo}`} alt={name || "Company"} className="object-cover" />
          ) : null}
          <AvatarFallback className={textSizeClasses[avatarSize]}>
            {getInitials()}
          </AvatarFallback>
        </Avatar>
      )}
      <span>{name || "Unknown"}</span>
    </Link>
  );
}
